import { TextCodes } from '@api/types/translation/TextCodes';
import {
  Title,
  WarrantyCustomerFields,
  WarrantyDealerFields,
  WarrantyPurchaseSelect,
} from '@components';
import { Grid } from '@mui/material';
import { t } from '@translations';

export const WarrantyUserInfoSection = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Title noDot variant='h3'>
          {t(TextCodes.Warranty.Block.Dealer)}
        </Title>
        <WarrantyDealerFields />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Title noDot variant='h3'>
          {t(TextCodes.Warranty.Block.Customer)}
        </Title>
        <WarrantyCustomerFields />
        <WarrantyPurchaseSelect />
      </Grid>
    </Grid>
  );
};
